module.exports = __webpack_public_path__ + "static/media/ui-icons-checklist-on.291bd4da.svg";